import React from 'react';
import type ProjectSettingsNotificationEmailType from '@atlassian/jira-spa-apps-project-settings-notification-email/src/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

export const LazyProjectSettingsNotificationEmail = lazyForPaint<
	typeof ProjectSettingsNotificationEmailType
>(() =>
	markAsProductBundleReady(
		import(
			/* webpackChunkName: "async-project-settings-notification-email", jiraSpaEntry: "async-project-settings-notification-email" */ '@atlassian/jira-spa-apps-project-settings-notification-email'
		),
	),
);

const AsyncProjectSettingsNotificationEmail = (): React.JSX.Element => (
	<LazyPage
		Page={LazyProjectSettingsNotificationEmail}
		pageId="project-settings-email-notifications"
		shouldShowSpinner
	/>
);

export default AsyncProjectSettingsNotificationEmail;
